// extracted by mini-css-extract-plugin
module.exports = {"swipe":"swipe-module--swipe--sdi9s","swipe-right":"swipe-module--swipe-right--2k9NP","swipeRight":"swipe-module--swipe-right--2k9NP"};